var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { Bits, Text } from '@wemogy/reactbase';
import { Provider } from 'mobx-react';
import AuthorizationStore from '../dataLayer/stores/AuthorizationStore';
import { EasterEgg, useModalStore } from '@wemogy/reactbase';
import DebugRoleModal from '../ui/debugFeatures/debugRoleModal/DebugRoleModal';
import GraphQlApiServiceFactory from '../dataLayer/api/graphQl/GraphQlApiServiceFactory';
import RestApiServiceFactory from '../dataLayer/api/rest/RestApiServiceFactory';
function getDebugRole(config) {
    var debugLevelRoles = [[]];
    var permissionLevels = Object.values(config.permissionLevels);
    permissionLevels.forEach(function (permissionLevel) {
        if (!debugLevelRoles[permissionLevel.pathIndex]) {
            debugLevelRoles[permissionLevel.pathIndex] = [];
        }
        debugLevelRoles[permissionLevel.pathIndex][permissionLevel.levelIndex] = Bits.emptyValue;
    });
    return {
        tenantId: 'debugTenant',
        name: 'debugRole',
        levelRoles: debugLevelRoles
    };
}
var AuthorizationProvider = function (_a) {
    var children = _a.children, config = _a.config, activeSubjectId = _a.activeSubjectId, activeTenantId = _a.activeTenantId, apiAuthenticationInformation = _a.apiAuthenticationInformation;
    var _b = __read(useState(AuthorizationStore.create({
        config: config,
        activeSubjectId: activeSubjectId,
        activeTenantId: activeTenantId,
        debugRole: getDebugRole(config)
    })), 1), authorizationStore = _b[0];
    var modalStore = useModalStore();
    var _c = __read(useState(false), 2), fetchingPermissions = _c[0], setFetchingPermissions = _c[1];
    useEffect(function () {
        EasterEgg.register('#rd#', function () {
            modalStore.openModal('debugRoleModal');
        });
    }, []);
    useEffect(function () {
        authorizationStore.setActiveTenantId(activeTenantId);
        GraphQlApiServiceFactory.setTenantId(activeTenantId);
        RestApiServiceFactory.setTenantId(activeTenantId);
    }, [activeTenantId]);
    useEffect(function () {
        if (!apiAuthenticationInformation) {
            return;
        }
        RestApiServiceFactory.setApiAuthenticationInformation(apiAuthenticationInformation);
        GraphQlApiServiceFactory.setApiAuthenticationInformation(apiAuthenticationInformation);
    }, [apiAuthenticationInformation]);
    useEffect(function () {
        authorizationStore.setActiveSubjectId(activeSubjectId);
    }, [activeSubjectId]);
    useEffect(function () {
        if (!activeSubjectId || !activeTenantId) {
            return;
        }
        setFetchingPermissions(true);
        authorizationStore.setActivePermissionCache(activeSubjectId, activeTenantId).then(function () {
            setFetchingPermissions(false);
        });
    }, [activeSubjectId, activeTenantId]);
    if (fetchingPermissions) {
        return React.createElement(Text, null, "Loading...");
    }
    return (React.createElement(Provider, { authorizationStore: authorizationStore },
        children,
        React.createElement(DebugRoleModal, null)));
};
export default AuthorizationProvider;
//# sourceMappingURL=AuthorizationProvider.js.map